import { render, staticRenderFns } from "./GuangzhouUnicomJd02.vue?vue&type=template&id=5a51a7b0&scoped=true"
import script from "./GuangzhouUnicomJd02.vue?vue&type=script&lang=js"
export * from "./GuangzhouUnicomJd02.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouUnicomJd02.vue?vue&type=style&index=0&id=5a51a7b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51a7b0",
  null
  
)

export default component.exports